import { ROLES } from '../constants/roles';
import { CATEGORIES } from '../constants/categories';

/**
 * UI Permissions utilities for role-based component visibility and access control
 * Note: These are for frontend UI permissions, not backend authorization
 */

/**
 * Check if user can edit inspection documents
 * @param {string} userRole - User's role name as string
 * @returns {boolean} - True if user can edit inspection documents
 */
export const canEditInspection = (userRole) => {
  if (!userRole) return false;
  
  return userRole === CATEGORIES.INSPECTION_DEPARTMENT;
};

/**
 * Check if user can edit laboratory documents  
 * @param {string} userRole - User's role name as string
 * @returns {boolean} - True if user can edit laboratory documents
 */
export const canEditLaboratory = (userRole) => {
  if (!userRole) return false;
  
  return userRole === CATEGORIES.CONTROL_LAB_VALIDATION;
};

/**
 * Check if user can view inspection tab
 * @param {string} userRole - User's role name as string
 * @returns {boolean} - True if user can view inspection tab
 */
export const canViewInspection = (userRole) => {
  if (!userRole) return false;
  
  return userRole === ROLES.core_Validator || 
         CATEGORIES.COMMITTEE_CATEGORIES.includes(userRole);
};

/**
 * Check if user can view laboratory tab
 * @param {string} userRole - User's role name as string
 * @returns {boolean} - True if user can view laboratory tab
 */
export const canViewLaboratory = (userRole) => {
  if (!userRole) return false;
  
  return userRole === ROLES.core_Validator || 
         CATEGORIES.COMMITTEE_CATEGORIES.includes(userRole);
};

/**
 * Check if user has any inspection permissions (edit or view)
 * @param {string} userRole - User's role name as string
 * @returns {boolean} - True if user has any inspection permissions
 */
export const hasInspectionAccess = (userRole) => {
  return canEditInspection(userRole) || canViewInspection(userRole);
};

/**
 * Check if user has any laboratory permissions (edit or view)
 * @param {string} userRole - User's role name as string
 * @returns {boolean} - True if user has any laboratory permissions
 */
export const hasLaboratoryAccess = (userRole) => {
  return canEditLaboratory(userRole) || canViewLaboratory(userRole);
};


